
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.977 3.495a1 1 0 011 1l.007 12.584 3.25-3.206a1 1 0 011.404 1.424l-4.987 4.92a1 1 0 01-1.412-.007l-4.885-4.92a1 1 0 011.42-1.41l3.21 3.234-.007-12.619a1 1 0 01.883-.993z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    